import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sm-shopqrnot-available',
  templateUrl: './shopqrnot-available.component.html',
  styleUrls: ['./shopqrnot-available.component.scss']
})
export class ShopqrnotAvailableComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
